<template>
    <div class="box contribute">
        <p class="title">じゃんたま見聞録の投稿について</p>
        <div class="formWrap">
            <el-form
                ref="contr"
                :rules="contrRules"
                :label-position="labelPosition"
                :model="contrForm"
                label-width="260px"
            >
                <el-form-item label="プレイヤー名" prop="name">
                    <el-input v-model="contrForm.name"></el-input>
                </el-form-item>
                <el-form-item label="プレイヤーID" prop="friendID">
                    <el-input v-model="contrForm.friendID"></el-input>
                    <span class="tip">※友人検索画面右上に表示</span>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="contrForm.email"></el-input>
                </el-form-item>
                <el-form-item class="required" label="メールアドレス（確認）" prop="reemail">
                    <el-input v-model="contrForm.reemail"></el-input>
                </el-form-item>
                <el-form-item label="牌譜URL" prop="mjManualUrl">
                    <el-input v-model="contrForm.mjManualUrl"></el-input>
                    <span class="tip">牌譜画面の「シェア」ボタンから確認できます</span>
                </el-form-item>
                <el-form-item label="ハイライトの詳細" prop="topDetail">
                    <el-input v-model="contrForm.topDetail"></el-input>
                    <span class="tip">記入例：東4局6巡目、早巡目の国士無双</span>
                </el-form-item>
                <el-form-item class="required" label="個人情報の取り扱いについて" prop="perChecked">
                    <el-checkbox v-model="contrForm.perChecked">同意する</el-checkbox>
                    <a
                        class="checked"
                        target="_blank"
                        href="https://mahjongsoul.com/privacy_policy"
                    >※プライバシーポリシーをご確認ください。</a>
                </el-form-item>
                <el-form-item label>
                    <el-button size="medium" type="info" plain @click="contrConfirm">上記内容で送信</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        const contr_reemail = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("もう一度メールアドレスを入力してください"));
            } else if (value !== this.contrForm.email) {
                callback(new Error("メールアドレスが一致しません"));
            } else {
                callback();
            }
        };
        const contr_perChecked = (rule, value, callback) => {
            if (!value) {
                callback(new Error("同意してください"));
            } else {
                callback();
            }
        };
        
        return {
            labelPosition: "right",
            contrRules: {
                name: [{ required: true, message: "必須", trigger: "blur" }],
                friendID: [
                    { required: true, message: "必須", trigger: "blur" }
                ],
                email: [
                    {
                        required: true,
                        message: "必須",
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: "正しいメールアドレスを入力してください",
                        trigger: ["blur", "change"]
                    }
                ],
                reemail: [
                    {
                        trigger: "blur",
                        validator: contr_reemail
                    }
                ],
                mjManualUrl: [{ required: true, message: "必須", trigger: "blur" }],
                perChecked: [
                    {
                        trigger: "change",
                        validator: contr_perChecked
                    }
                ]
            },
            contrForm: {
                name: "",
                friendID: "",
                email: "",
                reemail: "",
                mjManualUrl: "",
                topDetail: "",
                perChecked: false
            }
        };
    },
    created() {
        if (!this.$utils.isPC()) {
            this.labelPosition = "top";
        }
    },
    methods: {
        contrConfirm() {
            this.$refs["contr"].validate(valid => {
                if(!valid) {
                    return false;
                } else {
                    if(confirm('ご入力いたたいた内容で送信してよろしいでしょうか？')) {
                        this.confirm();
                    } else {
                        return false;
                    }
                }
            });
        },
        confirm() {
            let formData = new FormData();
            formData.set("name", this.contrForm.name);
            formData.set("friendID", this.contrForm.friendID);
            formData.set("email", this.contrForm.email);
            formData.set("mjManualUrl", this.contrForm.mjManualUrl);
            formData.set("topDetail", this.contrForm.topDetail);
            // contribute
            formData.set("type", "5")   
            formData.set("title", "じゃんたま見聞録の投稿について")

            this.$message({
                message:'送信が成功',
                duration: 10000
            });

            this.axios.post("/service/dismail",formData ).then(v => {
                console.log(v)
                if(v.data.retcode == 1) {
                    // 清空表单
                    /* this.contrForm.name = "";
                    this.contrForm.friendID = "";
                    this.contrForm.email = "";
                    this.contrForm.reemail = "";
                    this.contrForm.mjManualUrl = "";
                    this.contrForm.topDetail = "";
                    this.contrForm.perChecked = false; */
                }
            }).catch(e => {
                console.log(e)
            })
        }
    }
};
</script>


<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    color: #fff;

    & ::v-deep .el-button {
        background: transparent;
    }

    .title {
        width: 100%;
        background: #000;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(50px);
        .back {
            font-size: pxTorem(24px);
            cursor: pointer;
        }
    }
    .formWrap {
        width: 80%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px);

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        & ::v-deep .el-form-item__label {
            color: #fff;
        }
        & ::v-deep .el-input__inner {
            color: #fff;
        }
        & ::v-deep .el-textarea__inner {
            background: transparent;
            color: #fff;
            font-family: $japaneseFontFamily;
            &::-webkit-scrollbar {
                width: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: #001238;
                border-radius: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #407cfd;
                border-radius: 8px;
            }
        }
        .tip {
            font-size: pxTorem(10px);
            color: #afafaf;
        }
        .checked {
            color: #ac7f00;
        }
        .el-upload__tip {
            color: #afafaf;
            line-height: 1.5;
        }
        & ::v-deep .el-upload-list__item {
            height: auto !important;
            border: 1px solid transparent;
        }
        & ::v-deep .el-upload-list__item:hover {
            background: transparent;
            border: 1px solid #fff;
        }
        & ::v-deep .el-upload-list__item-name {
            color: #fff;
        }
        & ::v-deep .el-icon-document {
            color: #fff;
        }
        & ::v-deep .el-icon-close {
            color: #fff;
        }
        .inputsBox {
            .el-input:not(:last-child) {
                margin-bottom: 10px;
            }
        }
    }
}
</style>